import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    editingProject: null,
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    createTest(context, data) {
      return api.createTest(data);
    }
  }
};

appStore.registerModule('pledgeCornucopia', store);
